import CreditCardMethod from './credit-card-method';

export default CreditCardMethod;
